<script lang="ts" setup>
const { t } = useI18n();
const userStore = useUserStore();
const couponStore = useCouponStore();
</script>

<template>
  <form @submit.prevent="couponStore.applyCoupon" class="orderCouponForm">
    <BaseTextField
      v-model:value="couponStore.coupon"
      @clear="couponStore.deleteCoupon"
      :placeholder="t('placeholder')"
      autocomplete="none"
      bordered
      :clearable="!!couponStore.coupon"
      class="orderCouponForm__input"
    />
    <BaseButton
      :disabled="!userStore.authorized || !couponStore.coupon"
      :loading="couponStore.isLoading"
      block
      outlined
      dark
      type="submit"
      content-class="orderCouponForm__promoCode"
    >
      <Transition name="reel">
        <span
          v-if="!couponStore.isActivated"
          class="orderCouponForm__promoCode_state"
        >
          {{ t('apply') }}
        </span>
        <span v-else class="orderCouponForm__promoCode_state">
          {{ t('success') }}
        </span>
      </Transition>
    </BaseButton>
  </form>
</template>

<i18n>
ru:
  placeholder: Промокод или сертификат
  apply: Применить промокод
  success: ПРОМОКОД ПРИМЕНЕН

en:
  placeholder: Promo code or certificate
  apply: Apply promo code
  success: PROMO CODE APPLIED
</i18n>

<style lang="scss">
.orderCouponForm {
  display: flex;
  flex-direction: column;
  gap: 16px;

  &__input {
    width: 100%;
  }

  &__promoCode {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    &_state {
      display: block;
      position: absolute;
    }
  }
}
</style>
